import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.5)]'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 h-16 max-w-[1400px] mx-auto">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="text-2xl font-heading font-bold text-primary-500 tracking-wide">
            6080<span className="text-foreground-100">影视</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname.includes(cat.slug)
                  ? 'bg-primary-500/20 text-primary-500'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
          <div className="relative">
            <input
              type="text"
              placeholder="搜索剧集..."
              className="bg-background-200 text-foreground-200 text-sm rounded-full px-4 py-2 w-48 outline-none border border-background-400 focus:border-primary-500 focus:text-foreground-100 transition-all duration-200 placeholder:text-foreground-600"
            />
            <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
          </div>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-300">
          <div className="px-4 py-4 flex flex-col gap-2">
            <div className="relative mb-3">
              <input
                type="text"
                placeholder="搜索剧集..."
                className="bg-background-200 text-foreground-200 text-sm rounded-full px-4 py-2.5 w-full outline-none border border-background-400 focus:border-primary-500 transition-all duration-200 placeholder:text-foreground-600"
              />
              <i className="ri-search-line absolute right-4 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(cat.slug)
                    ? 'bg-primary-500/20 text-primary-500'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-2.5 rounded-lg text-sm text-foreground-400 hover:text-foreground-100 hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}